import React from 'react';
import { useLocation } from 'react-router-dom';
import { Play } from 'lucide-react';
import { getServiceVideo } from '../../data/videos';
import { generateVideoSchema } from '../../utils/schemaMarkup';
import { useSchemaMarkup } from '../../utils/useSchemaMarkup';

export const ServiceVideoSection = () => {
  const { pathname } = useLocation();
  const video = React.useMemo(() => getServiceVideo(pathname), [pathname]);
  const schemas = React.useMemo(() => (video ? [generateVideoSchema(video)] : []), [video]);
  const [playing, setPlaying] = React.useState(false);

  React.useEffect(() => setPlaying(false), [pathname]);
  useSchemaMarkup(schemas, `video-${pathname}`);

  if (!video) return null;

  return (
    <section className="py-16 bg-slate-900 text-white" data-testid="service-video-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-emerald-400 font-semibold text-sm uppercase tracking-wider">Watch & Learn</span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl mt-3 mb-3" data-testid="service-video-title">{video.title}</h2>
        <p className="text-stone-300 mb-8 max-w-3xl">{video.description}</p>
        <div className="relative aspect-video rounded-2xl overflow-hidden bg-black shadow-2xl">
          {playing ? (
            <iframe
              src={`${video.embedUrl}?autoplay=1&rel=0`}
              title={video.title}
              className="absolute inset-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              data-testid="service-video-iframe"
            />
          ) : (
            <button onClick={() => setPlaying(true)} className="group absolute inset-0 w-full h-full" aria-label={`Play video: ${video.title}`} data-testid="service-video-play-btn">
              <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" loading="lazy" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="w-20 h-20 rounded-full bg-emerald-600 flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                  <Play size={32} className="ml-1" fill="currentColor" />
                </span>
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
